import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propRequired, propMinValue, propLengthMax, propValidValue } from "../../common/entityStoreValidators";
import { EPrefItemDto, EPrefItemEditDto, newEPrefItem } from "./types";
import { useEPrefTypes } from "../../common/enum";
import { UseListStore } from "../../common/listStore";

export const EPrefTypeDialog = (props: {
    close: () => void;
    ePrefItem: EPrefItemEditDto | null;
    onChange(): void;
    useListStore: UseListStore<EPrefItemDto>;
}) => {
    const [{ useEmailPrefItemsDialogStore }] = useState(() => {
        const useEmailPrefItemsDialogStore = createEntityStore<EPrefItemEditDto>({
            data: props.ePrefItem === null ? newEPrefItem() : { ...props.ePrefItem },
            path: "settings/eprefType",
            fetchOnInit: false,
            id: props.ePrefItem != null ? props.ePrefItem.id : null,
            getNewId: p => p.id!,
            onSaved() {
                props.onChange();
                props.close();
                useEPrefTypes.getState().uninit();
            },
            propValidators: [
                propRequired("name"),
                propLengthMax("name", 50),
                propValidValue("priority", "priorityFormatted"),
                propRequired("priority"),
                propMinValue("priority", 0)
            ]
        });

        return { useEmailPrefItemsDialogStore };
    });

    const { save } = useEmailPrefItemsDialogStore(p => ({ save: p.save, id: p.entityId }));
    return <>
        <DialogTitle>{props.ePrefItem === null ? `New email preference type` : `Edit email preference type - ${props.ePrefItem?.name}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useEmailPrefItemsDialogStore)("name", "Name",)}</Grid>
                <Grid item xs={12}>{propBoolField(useEmailPrefItemsDialogStore)("isActive", "Active",)}</Grid>
                <Grid item xs={12}>{propBoolField(useEmailPrefItemsDialogStore)("isUnique", "Unique",)}</Grid>
                <Grid item xs={12}>{propNumberField(useEmailPrefItemsDialogStore)("priority", "priorityFormatted", "Priority",)}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};